<template>
  <div>
    <b-card>
      <b-card-text>Paylike</b-card-text>
      <b-button
        @click="paylikeInvoke()"
      >
        Invoke
      </b-button>
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BButton,
  },
  beforeCreate() {
    if (document.getElementById('paylike-script')) return // was already loaded
    const scriptTag = document.createElement('script')
    scriptTag.src = 'https://sdk.paylike.io/10.js'
    scriptTag.id = 'paylike-script'
    document.getElementsByTagName('head')[0].appendChild(scriptTag)
  },
  methods: {
    paylikeInvoke() {
      const setup = {
        currency: 'USD',
        locale: 'en',
      }
      const paylike = Paylike({ key: process.env.VUE_APP_PAYLIKE_PUBLIC_KEY })
      paylike.pay({
        test: process.env.VUE_APP_PAYLIKE_TEST === 'true',
        title: 'Debtia',
        description: 'Debtia Payment',
        fields: [
          {
            name: 'name',
            placeholder: 'John Doe',
          },
        ],
      }, (err, res) => {
        if (err) {
          return console.log(err)
        }
        console.log(res)
        const data = {}
        data.amount = res.custom.amount * 100
        data.currency = setup.currency
        console.log('Thank you!')
        return true
      })
    },
  },
  mounted() {
  },
}
</script>

<style>

</style>
